
import React, { useState, useEffect } from 'react';
import plane from '../../assets/plane.png';
import { ProductsData } from '../../data/testimonials'; 
import './Products.css';
import { useAutoAnimate } from '@formkit/auto-animate/react';

const Products = () => {
    const [parent] = useAutoAnimate({})

    const [menuProducts, setMenuproducts] = useState([]); 
    // console.log(parent);
    useEffect(() => {
        
        console.log('ProductsData:', ProductsData);
        setMenuproducts(ProductsData || []);
    }, []); 

    const Filter = (type) => {
        
        const filteredProducts = ProductsData.filter((product) => product.type === type);
        console.log('Filtered Products:', filteredProducts);
        setMenuproducts(filteredProducts);
    };

    return (
        <div className="container">
            <img src={plane} alt="h" />
            <h1>Our Featured Products</h1>

            <div className="products">
                <ul className="menu">
                    <li onClick={() => setMenuproducts(ProductsData || [])}>All</li>
                    <li onClick={() => Filter("skin care")}>Skin Care</li>
                    <li onClick={() => Filter("conditioner")}>Conditioners</li>
                    <li onClick={() => Filter("foundation")}>Foundations</li>
                </ul>

                <div className="list" ref={parent}>
                    
                    {Array.isArray(menuProducts) && menuProducts.length > 0 ? (
                        menuProducts.map((product, i) => (
                            <div className="product" key={i}>
                                <div className="left">
                                    <div className="name">
                                        <span>{product.name}</span>
                                        <span>{product.detail}</span>
                                    </div>
                                    <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                                        {product.price}$
                                    </span>
                                    <button className="btn">Shop Now</button>
                                </div>
                                <img src={product.img} alt="" />
                            </div>
                        ))
                    ) : (
                        <p>No products found.</p> 
                    )}
                </div>
            </div>
        </div>
    );
};

export default Products;
